import D from "./objectWithoutPropertiesLoose.mjs";
import d from "./extends.mjs";
import * as n from "react";
import e from "./index180.mjs";
import { clsx as U } from "./clsx.mjs";
import $ from "./useThemeProps.mjs";
import w from "./styled.mjs";
import { isAdornedStart as V, isFilled as I } from "./utils6.mjs";
import k from "./FormControlContext.mjs";
import { getFormControlUtilityClasses as G } from "./formControlClasses.mjs";
import { jsx as R } from "react/jsx-runtime";
import B from "./capitalize.mjs";
import C from "./isMuiElement.mjs";
import H from "./composeClasses.mjs";
const J = ["children", "className", "color", "component", "disabled", "error", "focused", "fullWidth", "hiddenLabel", "margin", "required", "size", "variant"], K = (o) => {
  const {
    classes: i,
    margin: m,
    fullWidth: l
  } = o, s = {
    root: ["root", m !== "none" && `margin${B(m)}`, l && "fullWidth"]
  };
  return H(s, G, i);
}, Q = w("div", {
  name: "MuiFormControl",
  slot: "Root",
  overridesResolver: ({
    ownerState: o
  }, i) => d({}, i.root, i[`margin${B(o.margin)}`], o.fullWidth && i.fullWidth)
})(({
  ownerState: o
}) => d({
  display: "inline-flex",
  flexDirection: "column",
  position: "relative",
  // Reset fieldset default style.
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  verticalAlign: "top"
}, o.margin === "normal" && {
  marginTop: 16,
  marginBottom: 8
}, o.margin === "dense" && {
  marginTop: 8,
  marginBottom: 4
}, o.fullWidth && {
  width: "100%"
})), M = /* @__PURE__ */ n.forwardRef(function(i, m) {
  const l = $({
    props: i,
    name: "MuiFormControl"
  }), {
    children: s,
    className: P,
    color: u = "primary",
    component: F = "div",
    disabled: a = !1,
    error: c = !1,
    focused: T,
    fullWidth: f = !1,
    hiddenLabel: p = !1,
    margin: _ = "none",
    required: g = !1,
    size: h = "medium",
    variant: b = "outlined"
  } = l, z = D(l, J), O = d({}, l, {
    color: u,
    component: F,
    disabled: a,
    error: c,
    fullWidth: f,
    hiddenLabel: p,
    margin: _,
    required: g,
    size: h,
    variant: b
  }), A = K(O), [x, L] = n.useState(() => {
    let r = !1;
    return s && n.Children.forEach(s, (t) => {
      if (!C(t, ["Input", "Select"]))
        return;
      const j = C(t, ["Select"]) ? t.props.input : t;
      j && V(j.props) && (r = !0);
    }), r;
  }), [S, W] = n.useState(() => {
    let r = !1;
    return s && n.Children.forEach(s, (t) => {
      C(t, ["Input", "Select"]) && (I(t.props, !0) || I(t.props.inputProps, !0)) && (r = !0);
    }), r;
  }), [E, v] = n.useState(!1);
  a && E && v(!1);
  const N = T !== void 0 && !a ? T : E;
  let y;
  if (process.env.NODE_ENV !== "production") {
    const r = n.useRef(!1);
    y = () => (r.current && console.error(["MUI: There are multiple `InputBase` components inside a FormControl.", "This creates visual inconsistencies, only use one `InputBase`."].join(`
`)), r.current = !0, () => {
      r.current = !1;
    });
  }
  const q = n.useMemo(() => ({
    adornedStart: x,
    setAdornedStart: L,
    color: u,
    disabled: a,
    error: c,
    filled: S,
    focused: N,
    fullWidth: f,
    hiddenLabel: p,
    size: h,
    onBlur: () => {
      v(!1);
    },
    onEmpty: () => {
      W(!1);
    },
    onFilled: () => {
      W(!0);
    },
    onFocus: () => {
      v(!0);
    },
    registerEffect: y,
    required: g,
    variant: b
  }), [x, u, a, c, S, N, f, p, y, g, h, b]);
  return /* @__PURE__ */ R(k.Provider, {
    value: q,
    children: /* @__PURE__ */ R(Q, d({
      as: F,
      ownerState: O,
      className: U(A.root, P),
      ref: m
    }, z, {
      children: s
    }))
  });
});
process.env.NODE_ENV !== "production" && (M.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: e.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: e.object,
  /**
   * @ignore
   */
  className: e.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * @default 'primary'
   */
  color: e.oneOfType([e.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), e.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: e.elementType,
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   * @default false
   */
  disabled: e.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: e.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: e.bool,
  /**
   * If `true`, the component will take up the full width of its container.
   * @default false
   */
  fullWidth: e.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: e.bool,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: e.oneOf(["dense", "none", "normal"]),
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: e.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: e.oneOfType([e.oneOf(["medium", "small"]), e.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: e.oneOf(["filled", "outlined", "standard"])
});
const de = M;
export {
  de as default
};
//# sourceMappingURL=FormControl.mjs.map
